import CoverLetterItemScreen from './CoverLetterItemScreen'

export default CoverLetterItemScreen
